<template>
  <footer
    class="bg-primary-purple-900 px-0 lg:px-[50px] pt-12.25 md:pt-15 lg:pt-20 text-white overflow-hidden"
  >
    <div class="pb-5 md:pb-8 lg:pb-[50px] container mx-auto">
      <div class="flex flex-wrap lg:flex-nowrap justify-between lg:gap-10 xl:gap-20 1.5xl:gap-36">
        <div class="w-full md:w-3/4 md:pr-1 flex flex-col gap-2.5 md:gap-[15px]">
          <a class="flex items-center gap-1.5" href="#" @click.prevent="navigateTo('/')">
            <div class="flex items-center justify-center w-8 h-8 rounded-full bg-white">
              <img
                class="mt-1"
                width="24"
                :src="require('@src/assets/images/app-logo.svg')"
                alt="logo"
              />
            </div>
            <h5 class="text-white">MyQampus</h5>
          </a>
          <p2 v-i18n="Footer" class="leading-6 text-primary-purple-50">F_DESC</p2>
        </div>
        <div class="flex flex-wrap w-full mt-7 md:mt-10 lg:mt-0 justify-between gap-5">
          <div class="footer-links sm:flex-1">
            <h5 v-i18n="Footer" class="pb-2.5 md:pb-[15px] text-white">F_L_COMPANY</h5>
            <div class="flex flex-col gap-[7px]">
              <p2>
                <router-link to="/refer">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_REFER_AND_EARN
                  </span>
                </router-link>
              </p2>
              <p2>
                <router-link to="/affiliate">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_AFFILIATE_PROGRAM
                  </span>
                </router-link>
              </p2>
              <!-- Brand Ambassador: hidden for now, kept for future use -->
              <!-- <p2>
                <a
                  v-i18n="Footer"
                  href="#"
                  class="text-primary-purple-50 opacity-90 hover:opacity-100"
                  @click.prevent="navigateTo('/brandAmbassador')"
                >
                  F_L_BRAND_AMBASSADOR
                </a>
              </p2> -->

              <!-- <p2>
                <router-link to="/learn-more">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    LEARN_MORE
                  </span>
                </router-link>
              </p2> -->
              <p>
                <a
                  v-i18n="Footer"
                  href="https://blogs.myqampus.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-primary-purple-50 opacity-90 hover:opacity-100"
                >
                  BLOGS
                </a>
              </p>
            </div>
          </div>
          <div class="footer-links sm:flex-1">
            <h5 v-i18n="Footer" class="pb-2.5 md:pb-[15px] text-white">F_L_TERMS</h5>
            <div class="flex flex-col gap-[7px]">
              <p2>
                <router-link to="/myqampus-faq">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_TERMS_FAQ
                  </span>
                </router-link>
              </p2>
              <p2>
                <router-link to="/about-us">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_TERMS_TOS
                  </span>
                </router-link>
              </p2>
              <p2>
                <router-link to="/terms-of-service">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_SERVICES
                  </span>
                </router-link>
              </p2>
              <p2>
                <router-link to="/privacy-policy">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    F_L_TERMS_POLICIES
                  </span>
                </router-link>
              </p2>
              <p2>
                <router-link to="/ai-agentic-support">
                  <span v-i18n="Footer" class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    AI_AGENTIC_SUPPORT
                  </span>
                </router-link>
              </p2>
            </div>
          </div>
          <div class="footer-links sm:flex-1">
            <h5 v-i18n="Footer" class="pb-2.5 md:pb-[15px] text-white">F_L_CONTACT</h5>
            <div class="flex flex-col gap-[7px]">
              <p2>
                <a
                  v-i18n="Footer"
                  href="https://www.google.com/maps/place/5900+Balcones+Dr,+Austin,+TX+78731,+USA/@30.3415203,-97.7597695,17z/data=!4m6!3m5!1s0x8644cae2feb064b3:0xfbcc19243aa6ddc0!8m2!3d30.3415204!4d-97.7548986!16s%2Fg%2F11c23lk3gj?entry=ttu&g_ep=EgoyMDI1MDQzMC4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D"
                  target="_blank"
                  class="text-primary-purple-50 opacity-90 hover:opacity-100"
                >
                  {{ appConfig.address }}
                </a>
              </p2>
              <p2>
                <a
                  v-i18n="Footer"
                  target="_blank"
                  href="https://wa.me/17374375551"
                  class="text-primary-purple-50 opacity-90 hover:opacity-100"
                  dir="ltr"
                >
                  {{ appConfig.contact }}
                </a>
              </p2>
              <p2>
                <a
                  href="mailto:hi@myqampus.com"
                  target="_blank"
                  class="text-primary-purple-50 opacity-90 hover:opacity-100"
                >
                  {{ appConfig.email }}
                </a>
              </p2>
              <p2>
                <router-link to="/contact-us">
                  <span class="text-primary-purple-50 opacity-90 hover:opacity-100">
                    Contact Us
                  </span>
                </router-link>
              </p2>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col-reverse md:flex-row gap-3 sm:gap-5 border-t-[1.5px] border-primary-purple-700 mt-5 lg:mt-[50px] pt-5 lg:pt-[50px] items-center md:justify-center lg:justify-between"
      >
        <p2 class="text-white leading-6 font-inter font-normal">
          {{ appConfig.copyright }}
        </p2>
        <div class="flex gap-3 md:gap-5 lg:gap-[50px]">
          <div v-for="(icon, index) in footerIcons" :key="index">
            <a :href="icon.iconLink" target="_blank">
              <icon class="icon" :icon="icon.iconName" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import generalMixin from '@src/mixins/general-mixins.js'
import appConfig from '@src/app.config'
import icon from '@src/components/icons/icon.vue'

export default {
  components: {
    icon,
  },
  mixins: [generalMixin],
  props: {},
  data() {
    return {
      appConfig,
      landingPage: 'landingPage',
      Footer: 'Footer',
      footerIcons: [
        {
          iconLink: 'https://www.facebook.com/myqampus',
          iconName: 'facebook',
        },
        {
          iconLink: 'https://instagram.com/myqampus',
          iconName: 'instagram',
        },
        {
          iconLink: 'https://www.linkedin.com/company/myqampus-com',
          iconName: 'linkedin-square',
        },
        {
          iconLink: 'https://twitter.com/myqampus',
          iconName: 'twitter-square',
        },
      ],
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },
  },
}
</script>
